/**
 * HPH Mobile Search Overlay
 * Full-screen search with predictive results.
 * Replaces Horizon's search modal on mobile.
 * Created: June 9, 2026
 */
(function() {
  'use strict';

  var overlay = document.getElementById('hph-mobile-search');
  var input = document.getElementById('hph-mobile-search-input');
  var clearBtn = document.getElementById('hph-mobile-search-clear');
  var resultsEl = document.getElementById('hph-mobile-search-results');
  var openBtn = document.querySelector('[data-hph-mobile-search-open]');
  var closeBtn = document.querySelector('[data-hph-mobile-search-close]');
  var debounceTimer;

  if (!overlay || !input || !openBtn) return;

  function open() {
    overlay.classList.add('hph-mobile-search--open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { input.focus(); }, 100);
  }

  function close() {
    overlay.classList.remove('hph-mobile-search--open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    input.value = '';
    while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);
    clearBtn.hidden = true;
  }

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);

  clearBtn.addEventListener('click', function() {
    input.value = '';
    clearBtn.hidden = true;
    while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);
    input.focus();
  });

  input.addEventListener('input', function() {
    clearBtn.hidden = input.value.trim().length === 0;
    clearTimeout(debounceTimer);
    var q = input.value.trim();
    if (q.length < 2) {
      while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);
      return;
    }
    debounceTimer = setTimeout(function() { search(q); }, 300);
  });

  /* Hide native search X */
  input.addEventListener('search', function() {
    clearBtn.hidden = input.value.trim().length === 0;
  });

  function search(query) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=show')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, query);
      })
      .catch(function() {
        while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);
      });
  }

  function renderResults(products, query) {
    while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);

    if (products.length === 0) {
      var emptyP = document.createElement('p');
      emptyP.className = 'hph-mobile-search__empty';
      emptyP.textContent = 'No products found for "' + query + '"';
      resultsEl.appendChild(emptyP);
      return;
    }

    var list = document.createElement('div');
    list.className = 'hph-mobile-search__products';

    products.forEach(function(p) {
      var a = document.createElement('a');
      a.href = p.url;
      a.className = 'hph-mobile-search__product';
      var soldOut = p.available === false;
      if (soldOut) a.classList.add('hph-mobile-search__product--sold-out');

      var imgWrap = document.createElement('div');
      imgWrap.className = 'hph-mobile-search__product-img-wrap';
      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2');
        img.alt = p.title;
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      }
      a.appendChild(imgWrap);

      var info = document.createElement('div');
      info.className = 'hph-mobile-search__product-info';

      var title = document.createElement('span');
      title.className = 'hph-mobile-search__product-title';
      title.textContent = p.title;
      info.appendChild(title);

      if (soldOut) {
        var badge = document.createElement('span');
        badge.className = 'hph-search__result-badge';
        badge.textContent = 'Sold out';
        info.appendChild(badge);
      }

      var price = document.createElement('span');
      price.className = 'hph-mobile-search__product-price';
      price.textContent = '$' + parseFloat(p.price).toFixed(2);
      info.appendChild(price);

      a.appendChild(info);
      list.appendChild(a);
    });

    resultsEl.appendChild(list);

    var viewAll = document.createElement('a');
    viewAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product&options[unavailable_products]=show';
    viewAll.className = 'hph-mobile-search__view-all';
    viewAll.textContent = 'View all results';
    resultsEl.appendChild(viewAll);
  }
})();
